import { ShipperRatingDTO } from 'shared/modules/ratings/data/ShipperRatingDTO';
import { Inline } from '@superdispatch/ui';
import { IconButton, Typography } from '@material-ui/core';
import { Rating } from 'shared/modules/ratings/Rating';
import { Delete, Edit } from '@material-ui/icons';
import styled from 'styled-components';
import { fitsRatingTimeWindow } from 'shared/modules/ratings/ShipperRatingUtils';
import { NullableDateString } from '@superdispatch/dates';
import { getAuthRole } from 'shared/auth/AuthToken';

const StyledIconButton = styled(IconButton)`
  padding: 4px;
  font-size: 16px;
`;

interface EditRatingProps {
  shipperRating: ShipperRatingDTO;
  lastOrderCompletedDate: NullableDateString;
  onClickRate: () => void;
  onClickDeleteRating: () => void;
}

export function EditRating({
  shipperRating,
  lastOrderCompletedDate,
  onClickRate,
  onClickDeleteRating,
}: EditRatingProps) {
  const authRole = getAuthRole();
  const isEditable =
    fitsRatingTimeWindow(lastOrderCompletedDate) ||
    authRole === 'admin' ||
    shipperRating.status === 'PENDING';

  return (
    <Inline verticalAlign="center" noWrap={true}>
      <Typography color="textSecondary">Your rating</Typography>

      <Rating
        type={shipperRating.rating === 'POSITIVE' ? 'positive' : 'negative'}
        size="small"
      />

      {isEditable && (
        <StyledIconButton aria-label="edit latest rating" onClick={onClickRate}>
          <Edit fontSize="inherit" />
        </StyledIconButton>
      )}

      {shipperRating.rating === 'NEGATIVE' && (
        <StyledIconButton
          aria-label="delete latest negative rating"
          onClick={onClickDeleteRating}
        >
          <Delete fontSize="inherit" />
        </StyledIconButton>
      )}
    </Inline>
  );
}
